import React, { useState } from 'react'
import {
  AttachFileOutlined,
  GifBoxOutlined,
  ImageOutlined,
  MicOutlined,
} from "@mui/icons-material";
import Dropzone from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { setPosts } from '../redux/appSlice';

const MyPostWidget = ({picturePath}) => {
    const [showDropBox,setShowDropBox]=useState(false)
    const [isLoading,setIsLoading]=useState(false)
    const [image,setImage]=useState(null)
    const [descrip,setDescrip]=useState("")
    const {_id}=useSelector((state)=>state.app.user)
    const {token}=useSelector((state)=>state.app)
    const dispatch=useDispatch()
    
    //this function will handle POST request 
    const handlePost=async()=>{
      // handle for data using form API
      const formData=new FormData()
      formData.append("userId",_id)
      formData.append('description',descrip)
      if(image){
        formData.append("picture",image)
        formData.append('picturePath',image.name)
      }
      setIsLoading(true)
      const response=await fetch(`https://thoughtful-erin-oyster.cyclic.app/posts`,{
        method:"POST",
        headers:{
          authorization:`Bearer ${token}`
        },
        body:formData
      })
      const posts= await response.json()
      dispatch(setPosts({
        posts
      }))
      setIsLoading(false)
      setImage(null)
      setDescrip("")
    }

  return (
    <div className='w-full space-y-2 rounded-md bg-white dark:bg-gray-900 p-4 divide-y divide-gray-200 h-fit'>
        <div className='w-full flex items-center gap-4'>
            <div className="w-[40px] h-[35px]">
                <img className='w-full h-full rounded-full object-cover' src={`${picturePath}`} alt="" />
            </div>
            <input onChange={(e)=>setDescrip(e.target.value)} className='w-full h-10 py-2 px-3 bg-gray-200 dark:bg-[#3D3B3B] rounded-3xl text-xs text-gray-500 dark:text-gray-400' type="text" placeholder="what's on your mind..." value={descrip}/>
        </div>
        {/* below code will toggle based on showDropBox */}
        {showDropBox && (
            <div>
            <Dropzone onDrop={(acceptedFiles) => setImage(acceptedFiles[0])}>
            {({ getRootProps, getInputProps }) => (
              <section className="col-span-full mt-2 w-full border-2 border-gray-400 p-4 rounded-md cursor-pointer">
                <div className="border-2 border-rose-700 border-dashed flex justify-center items-center p-2 "
                  {...getRootProps()}>
                  <input {...getInputProps()} />
                  {!image?(
                    <p className="text-sm dark:text-gray-300">Upload Here</p>
                  ):(
                    <p className="text-sm dark:text-gray-300">{image?.name}</p>
                  )}
        
                </div>  
              </section>
            )}
          </Dropzone>
            </div>
        )}
        
        <div className='w-full flex items-center justify-between gap-1 flex-wrap '>
            <div className="flex items-center gap-1 mt-2 cursor-pointer" onClick={()=>(setShowDropBox(!showDropBox))}>
                <ImageOutlined className='svg-size text-rose-600'/>
                <h4 className='text-xs text-gray-400'>Image</h4>
            </div>
            <div className="flex items-center gap-1 mt-2 cursor-pointer">
                <GifBoxOutlined className='svg-size text-rose-600'/>
                <h4 className='text-xs text-gray-400'>Gif</h4>
            </div>
            <div className="flex items-center gap-1 mt-2 cursor-pointer">
                <AttachFileOutlined className='svg-size text-rose-600'/>
                <h4 className='text-xs text-gray-400'>Attachment</h4>
            </div>
            <div className="flex items-center gap-1 mt-2 cursor-pointer">
                <MicOutlined className='svg-size text-rose-600'/>
                <h4 className='text-xs text-gray-400'>Audio</h4>
            </div>
            <div >
                <button disabled={!descrip} onClick={handlePost} className='bg-rose-700 shadow-md shadow-rose-700/50 text-xs rounded-xl py-1 px-4 mt-2 text-white'>{isLoading?"Posting...":"Post"}</button>
            </div>
        </div>
    </div>
  )
}

export default MyPostWidget